import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { BaseApiService } from '../../../../core/services/base-api.service';
import { ApiOptions } from '../../../../core/models/api-options.model';
import { CmsHttpClient } from '@cms_root/app/api-clients/cms/cms-http-client.service';
import { Settings, SettingsUpsert } from '../../models/site-settings.model';

@Injectable({
  providedIn: 'root'
})
export class SiteSettingsApiService extends BaseApiService {
  private readonly settingsURL = environment.cmsApi + 'api/settings';

  constructor(protected httpClient: CmsHttpClient) {
    super(httpClient);
  }

  getAll(options?: ApiOptions): Observable<Settings[]> {
    return this.httpClient.get<Settings[]>(`${this.settingsURL}`, { headers: this.getHeaders() });
  }

  getByName(name: string) {
    return this.httpClient.get<Settings>(`${this.settingsURL}?name=${name}`, { headers: this.getHeaders() });
  }

  getByShortname(name: string) {
    return this.httpClient.get<Settings>(`${this.settingsURL}?shortname=${name}`, { headers: this.getHeaders() });
  }

  edit(id, model: SettingsUpsert): Observable<Settings> {
    return this.httpClient.put<Settings>(`${this.settingsURL}/${id}`, model, {
      headers: this.getHeaders()
    });
  }
}
